import React from 'react';

import Categories from './categories';
import Tags from './tags';

const MenuCategoriesComponent = React.memo(() => (
  <div className="px6">
    <Categories />
    <Tags />
  </div>
));

MenuCategoriesComponent.displayName = 'MenuCategoriesComponent';

export default MenuCategoriesComponent;
